module.exports = __webpack_public_path__ + "img/dingbu1.9fb3d5cb.png";